import React from 'react';

export function ThirrstyBadge({ size = 'sm', className = '', testId = 'thirrsty-venue-badge' }) {
  const compact = size === 'xs';
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border border-[#F6B24A]/40 bg-[#F6B24A]/15 ${compact ? 'px-1.5 py-0.5' : 'px-2 py-0.5'} ${className}`}
      data-testid={testId}
      title="Official Thirrsty.com venue"
    >
      <img
        src="/logo.png"
        alt=""
        className={`${compact ? 'h-3 w-3' : 'h-3.5 w-3.5'} rounded-sm object-cover`}
      />
      <span className={`${compact ? 'text-[9px]' : 'text-[10px]'} font-semibold leading-none tracking-wide`}>
        <span className="text-white">Thirrsty</span>
        <span className="text-[#F6B24A]">.com</span>
      </span>
    </span>
  );
}

export default ThirrstyBadge;
